var map = {
	"./Ace Duck/Ace Duck - Color.png": 7274,
	"./Ace Duck/Ace Duck - Grey.png": 2441,
	"./Antrax/Antrax - Color.png": 6535,
	"./Antrax/Antrax - Grey.png": 4981,
	"./April/April - Color.png": 3154,
	"./April/April - Grey.png": 3817,
	"./Armaggon/Armaggon - Color.png": 1637,
	"./Armaggon/Armaggon - Grey.png": 2640,
	"./Aska/Aska - Color.png": 1713,
	"./Aska/Aska - Grey.png": 4942,
	"./Attila/Attila - Color.png": 2218,
	"./Attila/Attila - Grey.png": 6776,
	"./Baxter/Baxter - Color.png": 4789,
	"./Baxter/Baxter - Grey.png": 5388,
	"./Beebop/Beebop - Color.png": 9642,
	"./Beebop/Beebop - Grey.png": 9540,
	"./Burne/Burne - Color.png": 8030,
	"./Burne/Burne - Grey.png": 9542,
	"./Casey Jones/Casey Jones - Color.png": 5370,
	"./Casey Jones/Casey Jones - Grey.png": 6133,
	"./Chrome Dome/Chrome Dome - Color.png": 1206,
	"./Chrome Dome/Chrome Dome - Grey.png": 6366,
	"./Dask/Dask - Color.png": 6482,
	"./Dask/Dask - Grey.png": 8395,
	"./Dirtbag/Dirtbag - Color.png": 8245,
	"./Dirtbag/Dirtbag - Grey.png": 1369,
	"./Donatello/Donatello - Color.png": 5469,
	"./Donatello/Donatello - Grey.png": 8100,
	"./Fugitoid/Fugitoid - Color.png": 3614,
	"./Fugitoid/Fugitoid - Grey.png": 238,
	"./Genghis/Genghis - Color.png": 6293,
	"./Genghis/Genghis - Grey.png": 3819,
	"./Granitor/Granitor - Color.png": 378,
	"./Granitor/Granitor - Grey.png": 9796,
	"./Groundchuck/Groundchuck - Color.png": 8582,
	"./Groundchuck/Groundchuck - Grey.png": 149,
	"./Hothead/Hothead - Color.png": 8593,
	"./Hothead/Hothead - Grey.png": 6969,
	"./Irma/Irma - Color.png": 708,
	"./Irma/Irma - Grey.png": 3808,
	"./Kala/Kala - Color.png": 5512,
	"./Kala/Kala - Grey.png": 8069,
	"./Karai/Karai - Color.png": 1040,
	"./Karai/Karai - Grey.png": 6073,
	"./Leatherhead/Leatherhead - Color.png": 8144,
	"./Leatherhead/Leatherhead - Grey.png": 752,
	"./Leonardo/Leonardo - Color.png": 7464,
	"./Leonardo/Leonardo - Grey.png": 7026,
	"./Lotus Blossom/Lotus Blossom - Color.png": 9803,
	"./Lotus Blossom/Lotus Blossom - Grey.png": 6698,
	"./Mecaturtle/Mecaturtle - Color.png": 328,
	"./Mecaturtle/Mecaturtle - Grey.png": 8412,
	"./Metalhead/Metalhead - Color.png": 2598,
	"./Metalhead/Metalhead - Grey.png": 7060,
	"./Michelangelo/Michelangelo - Color.png": 7295,
	"./Michelangelo/Michelangelo - Grey.png": 9509,
	"./Mona Lisa/Mona Lisa - Color.png": 2239,
	"./Mona Lisa/Mona Lisa - Grey.png": 2445,
	"./Mondo Gecko/Mondo Gecko - Color.png": 1456,
	"./Mondo Gecko/Mondo Gecko - Grey.png": 2380,
	"./Muckman/Muckman - Color.png": 6476,
	"./Muckman/Muckman - Grey.png": 5002,
	"./Napoleon/Napoleon - Color.png": 5566,
	"./Napoleon/Napoleon - Grey.png": 9635,
	"./Rahzar/Rahzar - Color.png": 8654,
	"./Rahzar/Rahzar - Grey.png": 8007,
	"./Raphael/Raphael - Color.png": 5675,
	"./Raphael/Raphael - Grey.png": 7166,
	"./Rasputin/Rasputin - Color.png": 9426,
	"./Rasputin/Rasputin - Grey.png": 2560,
	"./Rat King/Rat King - Color.png": 1908,
	"./Rat King/Rat King - Grey.png": 9338,
	"./Ray Fillet/Ray Fillet - Color.png": 1519,
	"./Ray Fillet/Ray Fillet - Grey.png": 8587,
	"./Rocksteady/Rocksteady - Color.png": 4129,
	"./Rocksteady/Rocksteady - Grey.png": 1281,
	"./Shogun/Shogun - Color.png": 7587,
	"./Shogun/Shogun - Grey.png": 59,
	"./Slash/Slash - Color.png": 6022,
	"./Slash/Slash - Grey.png": 1346,
	"./Splinter/Splinter - Color.png": 8585,
	"./Splinter/Splinter - Grey.png": 3707,
	"./Tatsu/Tatsu - Color.png": 3473,
	"./Tatsu/Tatsu - Grey.png": 9966,
	"./Tempestra/Tempestra - Color.png": 4957,
	"./Tempestra/Tempestra - Grey.png": 8763,
	"./Tokka/Tokka - Color.png": 688,
	"./Tokka/Tokka - Grey.png": 1966,
	"./Tora/Tora - Color.png": 5537,
	"./Tora/Tora - Grey.png": 490,
	"./Traag/Traag - Color.png": 3698,
	"./Traag/Traag - Grey.png": 2022,
	"./Triceraton/Triceraton - Color.png": 2393,
	"./Triceraton/Triceraton - Grey.png": 7428,
	"./Usagi/Usagi - Color.png": 8015,
	"./Usagi/Usagi - Grey.png": 437,
	"./Vernon/Vernon - Color.png": 1958,
	"./Vernon/Vernon - Grey.png": 5948,
	"./Wingnut/Wingnut - Color.png": 926,
	"./Wingnut/Wingnut - Grey.png": 1865,
	"./Zach/Zach - Color.png": 7086,
	"./Zach/Zach - Grey.png": 1073,
	"./Zak/Zak - Color.png": 2130,
	"./Zak/Zak - Grey.png": 7519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3280;